// File: src/components/common/MenuAction.js
// -----------------------------------------------------
import React from 'react';
import { MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import PropTypes from 'prop-types';

/**
 * Menu action item component
 */
const MenuAction = ({ 
  icon, 
  text, 
  onClick, 
  danger = false,
  ...props 
}) => {
  const dangerStyles = danger ? { 
    color: 'error.main', 
    '& .MuiListItemIcon-root': { color: 'error.main' } 
  } : {};

  return (
    <MenuItem 
      onClick={onClick} 
      sx={{ ...dangerStyles, ...props.sx }}
      {...props}
    >
      {icon && (
        <ListItemIcon sx={danger ? { color: 'error.main' } : {}}>
          {React.cloneElement(icon, { fontSize: 'small' })}
        </ListItemIcon>
      )}
      <ListItemText>{text}</ListItemText>
    </MenuItem>
  );
};

MenuAction.propTypes = {
  icon: PropTypes.element,
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  danger: PropTypes.bool,
  sx: PropTypes.object
};

export default MenuAction;